export default __webpack_public_path__ + "static/media/leadership-involvement.5e7b31d3.pdf";